import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import { leaseDateFormat } from "../../utils/utils";
class ParkingStorageSignage extends React.Component {
  countError = "";
  state = {
    escalationChargeType: "",
    escalationIndex: 0,
    showCharges: false,
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    applicableValue: "",
    applicableValueStatic: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    keyvalue: "",
    leaseTermYY: "",
    leaseTermMM: "",
    leaseTermDD: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    to: "",
    isOpen: false,
    showAddBtn: false,
    fromDate: "",
    toDate: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    period: 1,
    redirect: false,
    occupiers: { count: 2, occupiers: [{ countUnits: 1 }] },
    showParking: false,
    showStorage: false,
    showSignage: false,
    parkingStorageSignage: [],
    parkingCharges: {
      parking2W: "",
      parking4W: "",
      parkingOther: "",
    },
    initialValues: {
      pkgLogic: {
        chargeType: "",
        chargeTypeText: "",
        period: "",
        fromDate: "",
        toDate: "",
        count: "",
        type: "",
        dueDate: "",
        rate: "",
        rateTerm: "",
        onArea: "",
        frequency: "",
        area: "",
        strName: "",
        sngName: "",
        location: "",
      },
    },
    toggleParkingForm: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showParkingForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes" || e.target.value === "hybrid") {
      this.setState({
        toggleParkingForm: true,
        showCharges: false,
      });
    } else if (e.target.value === "no") {
      this.setState({
        toggleParkingForm: false,
        showCharges: true,
      });
    } else if (e.target.value === "Select") {
      this.setState({ showCharges: false });
    }
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  hadleOptionChange = (event, values, setFieldValue) => {

    console.log("form change");

    this.setState({ escalationChargeType: event.target.value });
    if (
      this.state.parkingStorageSignage[event.target.value] !== undefined &&
      this.state.parkingStorageSignage[event.target.value].length > 0 &&
      this.state.parkingStorageSignage[event.target.value][
        this.state.parkingStorageSignage[event.target.value].length - 1
      ].toDate == values.to
    ) {
      this.state.initialValues.pkgLogic.chargeType = "";
      this.setState({
        popupalertMessage: true,
        popupMessageContent: "Values For this type has completed the period",
      });
      return false;
    }



    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    var _parkingStorageSignage = this.state.parkingStorageSignage;
    if (
      _parkingStorageSignage[event.target.value] == undefined ||
      _parkingStorageSignage[event.target.value].length == 0
    ) {
      this.state.fromDate = values.from;
      this.state.toDate = "";
      this.state.period = 1;
    } else {
      this.state.fromDate = getToDate(
        _parkingStorageSignage[event.target.value][
          _parkingStorageSignage[event.target.value].length - 1
        ].toDate,
        2,
        0,
        0
      );
      this.state.toDate = "";
      this.state.period =
        this.state.parkingStorageSignage[event.target.value].length + 1;
    }

    this.setState({});

    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    var index = event.nativeEvent.target.selectedIndex;
    var text = event.nativeEvent.target[index].label;
    this.state.initialValues.pkgLogic.chargeTypeText = text;
    this.state.initialValues.pkgLogic.chargeType = event.target.value;

    //-------chaning pkg count--------------------//
    let eventType = event.target.value.replace(/ /g, '_').toLowerCase();
    if (this.state.initialValues.additionalDetails.parkingDetails[eventType]) {
      this.state.initialValues.pkgLogic.count = this.state.initialValues.additionalDetails.parkingDetails[eventType];
      this.setState({});
      setFieldValue("pkgLogic.count", this.state.initialValues.pkgLogic.count);
    }

    if (
      event.target.value === "Parking 2W" ||
      event.target.value === "Parking 4W" ||
      event.target.value === "Parking Other"
    ) {
      this.setState({
        showParking: true,
        showStorage: false,
        showSignage: false,
      });
    } else if (event.target.value === "Storage") {
      this.setState({
        showParking: false,
        showStorage: true,
        showSignage: false,
      });
    } else if (event.target.value === "Signage") {
      this.setState({
        showParking: false,
        showStorage: false,
        showSignage: true,
      });
    } else {
      this.setState({
        showParking: false,
        showStorage: false,
        showSignage: false,
      });
    }
  };

  editPkg(index, values, key) {

    console.log(this.state.parkingStorageSignage[key][index]);
    this.state.applicableValue = this.state.applicableValueStatic;
    if (this.state.applicableValue != 'no') {
      this.state.toggleParkingForm = true;
      this.state.initialValues.pkgLogic.chargeType = this.state.parkingStorageSignage[key][index].chargeType;
    }


    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    this.state.period = this.state.parkingStorageSignage[key][index].period;

    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.parkingStorageSignage[key][index].periodTermDD,
      periodTermMM: this.state.parkingStorageSignage[key][index].periodTermMM,
      periodTermYY: this.state.parkingStorageSignage[key][index].periodTermYY,
    });
    if (
      this.state.parkingStorageSignage[key][index].chargeType ===
      "Parking 2W" ||
      this.state.parkingStorageSignage[key][index].chargeType ===
      "Parking 4W" ||
      this.state.parkingStorageSignage[key][index].chargeType ===
      "Parking Other"
    ) {
      this.setState({
        showParking: true,
        showStorage: false,
        showSignage: false,
      });
    } else if (
      this.state.parkingStorageSignage[key][index].chargeType === "Storage"
    ) {
      this.setState({
        showParking: false,
        showStorage: true,
        showSignage: false,
      });
    } else if (
      this.state.parkingStorageSignage[key][index].chargeType === "Signage"
    ) {
      this.setState({
        showParking: false,
        showStorage: false,
        showSignage: true,
      });
    } else {
      this.setState({
        showParking: false,
        showStorage: false,
        showSignage: false,
      });
    }
    values.pkgLogic = this.state.parkingStorageSignage[key][index];
    this.state.fromDate = this.state.parkingStorageSignage[key][index].fromDate;
    this.state.toDate = this.state.parkingStorageSignage[key][index].toDate;

    this.setState({});
  }

  addDetails = (values, resetForm, setFieldValue) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });

        return false;
      }
      values.pkgLogic.chargeTypeText =
        this.state.initialValues.pkgLogic.chargeTypeText;
      var _parkingStorageSignage = this.state.parkingStorageSignage;
      values.pkgLogic.period = this.state.period;
      values.pkgLogic.fromDate = this.state.fromDate;
      values.pkgLogic.toDate = this.state.toDate;
      values.pkgLogic.periodTermYY = this.state.periodTermYY;
      values.pkgLogic.periodTermMM = this.state.periodTermMM;
      values.pkgLogic.periodTermDD = this.state.periodTermDD;
      if (
        _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType] ==
        undefined
      ) {
        _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType] =
          [];
      }
      _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType].push(
        values.pkgLogic
      );
      this.setState({
        parkingStorageSignage: _parkingStorageSignage,
        showParking: false,
        showStorage: false,
        showSignage: false,
        showAddBtn: false,
      });
      var _initialValues = this.state.initialValues;
      _initialValues.pkgLogic.chargeType = "";
      this.state.periodTermDD = "";
      this.state.periodTermMM = "";
      this.state.periodTermYY = "";
      setFieldValue("pkgLogic.rate", "");
      setFieldValue("pkgLogic.escalationPercent", "");
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
      this.mainFormValidator.hideMessages();
      // resetForm();
      // this.setState({
      //   fromDate: getToDate(this.state.toDate, 2, 0, 0),
      //   toDate: "",
      // });
    } else {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      }
      values.pkgLogic.chargeTypeText =
        this.state.initialValues.pkgLogic.chargeTypeText;
      var _parkingStorageSignage = this.state.parkingStorageSignage;
      values.pkgLogic.period = this.state.period;
      values.pkgLogic.fromDate = this.state.fromDate;
      values.pkgLogic.toDate = this.state.toDate;
      values.pkgLogic.periodTermYY = this.state.periodTermYY;
      values.pkgLogic.periodTermMM = this.state.periodTermMM;
      values.pkgLogic.periodTermDD = this.state.periodTermDD;
      if (
        _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType] ==
        undefined
      ) {
        _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType] =
          [];
      }
      _parkingStorageSignage[this.state.initialValues.pkgLogic.chargeType][
        this.state.currentIndex
      ] = { ...values.pkgLogic };
      this.setState({
        parkingStorageSignage: _parkingStorageSignage,
        showParking: false,
        showStorage: false,
        showSignage: false,
      });
      var _initialValues = this.state.initialValues;
      _initialValues.pkgLogic.chargeType = "";
      this.state.periodTermDD = "";
      this.state.periodTermMM = "";
      this.state.periodTermYY = "";
      this.mainFormValidator.hideMessages();
      resetForm();
      this.state.disableOnEdit = false;
      this.state.currentIndex = null;
      this.state.readOnEdit = false;
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
      // this.setState({
      //   fromDate: getToDate(this.state.toDate, 2, 0, 0),
      //   toDate: "",
      // });
    }
  };

  resetDetails = (values, resetForm) => {
    this.setState({
      // parkingStorageSignage: _parkingStorageSignage,
      showParking: false,
      showStorage: false,
      showSignage: false,
    });
    var _initialValues = this.state.initialValues;
    _initialValues.pkgLogic.chargeType = "";
    this.state.periodTermDD = "";
    this.state.periodTermMM = "";
    this.state.periodTermYY = "";
    this.mainFormValidator.hideMessages();
    resetForm();
    this.state.disableOnEdit = false;
    this.state.currentIndex = null;
    this.state.readOnEdit = false;
    this.setState({});
  };

  handleReset = () => {
    this.setState({
      // parkingStorageSignage: _parkingStorageSignage,
      showParking: false,
      showStorage: false,
      showSignage: false,
    });
    var _initialValues = this.state.initialValues;
    _initialValues.pkgLogic.chargeType = "";
    this.state.periodTermDD = "";
    this.state.periodTermMM = "";
    this.state.periodTermYY = "";
    this.mainFormValidator.hideMessages();
    this.state.disableOnEdit = false;
    this.state.currentIndex = null;
    this.state.readOnEdit = false;
    this.setState({});
  };

  componentDidMount() {
    let athis = this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-pss-details?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      athis.state.to = data.to;
      athis.state.fromDate = data.from;
      athis.state.applicableValue = data.chargesApplicable;
      athis.state.applicableValueStatic = data.chargesApplicable;
      if (data.parkingStorageSignage.length > 0) {
        
        athis.setState({
          fromDate: getToDate(
            data.parkingStorageSignage[data.parkingStorageSignage.length - 1]
              .toDate,
            2,
            0,
            0
          ),
        });
      }
      if (data.chargesApplicable === "yes") {
        athis.setState({
          toggleParkingForm: true,
        });
      } else {
        athis.setState({
          toggleParkingForm: false,
          showCharges: true,
        });
      }
      athis.setState({
        initialValues: data,
        parkingStorageSignage: data.parkingStorageSignage,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        period:
          data.parkingStorageSignage.length > 0
            ? data.parkingStorageSignage.length + 1
            : 1,
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-pss-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.to = data.to;
    //     this.state.fromDate = data.from;
    //     this.state.applicableValue = data.chargesApplicable;
    //     this.state.applicableValueStatic = data.chargesApplicable;
    //     if (data.parkingStorageSignage.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.parkingStorageSignage[
    //       //     data.parkingStorageSignage.length - 1
    //       //   ].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.parkingStorageSignage[data.parkingStorageSignage.length - 1]
    //             .toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     if (data.chargesApplicable === "yes") {
    //       this.setState({
    //         toggleParkingForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleParkingForm: false,
    //         showCharges: true,
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       parkingStorageSignage: data.parkingStorageSignage,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       period:
    //         data.parkingStorageSignage.length > 0
    //           ? data.parkingStorageSignage.length + 1
    //           : 1,
    //     });
    //     // if (
    //     //   (data.parkingStorageSignage[
    //     //     data.parkingStorageSignage.length - 1
    //     //   ].toDate = data.to)
    //     // ) {
    //     //   this.setState({
    //     //     showForm: false,
    //     //   });
    //     // }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _rdd = this.state.parkingStorageSignage;
    _rdd[this.state.keyvalue].splice(this.state.index_val, 1);
    this.setState({
      parkingStorageSignage: _rdd,
      showForm: true,
    });
    this.state.period--;
    this.setState({
      delete: false,
      index_val: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  calculateRentRate(e, values, setFieldValue) {
    if (this.state.period > 1) {
      console.log(
        values.parkingStorageSignage[values.pkgLogic.chargeType][
          values.parkingStorageSignage[values.pkgLogic.chargeType].length - 1
        ].rate
      );
      console.log(values);
      setFieldValue(
        "pkgLogic.rate",
        (
          Number(
            values.parkingStorageSignage[values.pkgLogic.chargeType][
              values.parkingStorageSignage[values.pkgLogic.chargeType].length -
              1
            ].rate
          ) *
          (1 + Number(e.target.value) / 100)
        ).toFixed(2)
      );
    }
  }

  calculateEscalationPercent(e, values, setFieldValue) {
    if (
      this.state.period > 1 &&
      this.state.parkingStorageSignage[this.state.escalationChargeType][
        this.state.escalationIndex
      ].rate !== 0
    ) {
      setFieldValue(
        "pkgLogic.escalationPercent",
        (
          ((Number(e.target.value) -
            Number(
              this.state.parkingStorageSignage[this.state.escalationChargeType][
                this.state.escalationIndex
              ].rate
            )) /
            Number(
              this.state.parkingStorageSignage[this.state.escalationChargeType][
                this.state.parkingStorageSignage[
                  this.state.escalationChargeType
                ].length - 1
              ].rate
            )) *
          100
        ).toFixed(2)
      );
    }
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          //to={"/createlease/rent-deposit-details/" + this.props.match.params.id}
          to={
            `/${urlPath[1]}/rent-deposit-details/` + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Other Charges</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Parking, Storage & Signage</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                values.chargesApplicable = this.state.applicableValue;
                if (!this.applicableValidator.allValid()) {
                  console.log(this.validator);
                  this.applicableValidator.showMessages();
                  return false;
                }

                let count = 0;
                for (var key in this.state.parkingStorageSignage) {
                  if (this.state.parkingStorageSignage[key].length > 0) {
                    count = 1;
                    break;
                  }
                }
                if (count == 0 && this.state.applicableValue !== "no") {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }

                var parkingStorageSignage = {
                  ...this.state.parkingStorageSignage,
                };
                values.parkingStorageSignage = parkingStorageSignage;
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-pss-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">
                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>From</label>
                            <div className="position-relative">
                              <Field type="date" name="from" />
                              <ErrorMessage
                                name="from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>To</label>
                            <div className="position-relative">
                              <Field type="date" name="to" />
                              <ErrorMessage
                                name="to"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Charges Applicable <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="chargesApplicable"
                                value={this.state.applicableValue}
                                onChange={(e) => {
                                  this.state.applicableValue = e.target.value;
                                  this.showParkingForm(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="Select" label="Select" defaultValue />
                                <option value="yes" label="Yes" />
                                <option value="no" label="No" />
                                <option value="hybrid" label="Hybrid" />
                              </Field>
                              {this.applicableValidator.message(
                                "Charges Applicable",
                                this.state.applicableValue,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                          {this.state.toggleParkingForm && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Charge Type <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="pkgLogic.chargeType"
                                    disabled={this.state.disableOnEdit}
                                    value={this.state.initialValues.pkgLogic.chargeType}
                                    onChange={(e) => {
                                      this.hadleOptionChange(e, values, setFieldValue);
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="Parking 2W" label="Parking 2W" />
                                    <option value="Parking 4W" label="Parking 4W" />
                                    <option value="Parking Other" label="Parking Other" />
                                    <option value="Storage" label="Storage" />
                                    <option value="Signage" label="Signage" />
                                  </Field>
                                </div>
                              </div>
                              <div className="newGridSectionInner">
                                <label>Period</label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="pkgLogic.period"
                                    value={this.state.period}
                                    disabled={this.state.disableOnEdit}
                                    onChange={(e) => {
                                      this.state.period = e.target.value;
                                    }}
                                  />
                                  <ErrorMessage
                                    name="pkgLogic.period"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                              <div className="newGridSectionInner">
                                <label>Period Term</label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="periodTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermYY}
                                        onChange={(e) => {
                                          this.state.periodTermYY = e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="periodTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermMM}
                                        onChange={(e) => {
                                          this.state.periodTermMM = e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="periodTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermDD}
                                        onChange={(e) => {
                                          this.state.periodTermDD = e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="mfLogic.periodTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                              {this.state.showParking && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={true}
                                        name="pkgLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={true}
                                        name="pkgLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>PKG Count</label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pkgLogic.count"
                                      />
                                      {this.validator.message(
                                        "PKG Count",
                                        values.pkgLogic.count,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      PKG Rate UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.uom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({ autoForceUpdate: this });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Slot" label="Per Slot" />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "PKG UOM",
                                        values.pkgLogic.uom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  {values.pkgLogic.uom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        PKG Area <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pkgLogic.area"
                                          onChange={(e) => {
                                            this.validator = new SimpleReactValidator({ autoForceUpdate: this });
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                          <option value="Actual Parking Area" label="Actual Parking Area" />
                                        </Field>
                                        {this.validator.message(
                                          "PKG Area",
                                          values.pkgLogic.area,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {values.pkgLogic.area === "Actual Parking Area" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        PKG Actual Area <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="pkgLogic.actualArea"
                                        />
                                        {this.validator.message(
                                          "PKG Actual Area",
                                          values.pkgLogic.actualArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="newGridSectionInner">
                                    <label>
                                      PKG Rate (Per Month) <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pkgLogic.rate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(e, values, setFieldValue);
                                        }}
                                      />
                                      {this.validator.message(
                                        "PKG Rate",
                                        values.pkgLogic.rate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[
                                    this.state.escalationChargeType
                                    ][this.state.escalationIndex] != "undefined" &&
                                    this.state.parkingStorageSignage[
                                      this.state.escalationChargeType
                                    ][this.state.escalationIndex].rate != 0 && (
                                      <div className="newGridSectionInner">
                                        <label>Escalation %</label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pkgLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.pkgLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      PKG Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.rateTerm"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "Rate Term",
                                        values.pkgLogic.rateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      PKG Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.frequency"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "Frequency",
                                        values.pkgLogic.frequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      PKG Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueDate"
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueType"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueFrequency"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pkgLogic.pkgDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.applicableValue === 'hybrid' && (
                                    <div className="newGridSectionInner">
                                      <label>Free Parking</label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="pkgLogic.freeParking"
                                        />
                                        {this.validator.message(
                                          "Free parking",
                                          values.pkgLogic.freeParking,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                              {this.state.showStorage && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pkgLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pkgLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Storage Type (STR) <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.type"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Basic Store" label="Basic Store" />
                                        <option value="Cold Store" label="Cold Store" />
                                        <option value="Others" label="Others" />
                                      </Field>
                                      {this.validator.message(
                                        "Storage Type (STR)",
                                        values.pkgLogic.type,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>STR Name</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="pkgLogic.strName"
                                      />
                                      {this.validator.message(
                                        "STR Name",
                                        values.pkgLogic.strName,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      STR UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.uom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Slot" label="Per Slot" />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "STR UOM",
                                        values.pkgLogic.uom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {values.pkgLogic.uom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="pkgLogic.onArea"
                                        />
                                        {this.validator.message(
                                          "On Area",
                                          values.pkgLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      STR Rate <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pkgLogic.rate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(e, values, setFieldValue);
                                        }}
                                      />
                                      {this.validator.message(
                                        "STR Rate",
                                        values.pkgLogic.rate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[this.state.escalationChargeType][this.state.escalationIndex] !== "undefined" &&
                                    this.state.parkingStorageSignage[this.state.escalationChargeType][this.state.escalationIndex].rate !== 0 && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          Escalation %
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pkgLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.pkgLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      STR Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.rateTerm"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "STR Rate Term",
                                        values.pkgLogic.rateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      STR Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.frequency"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "STR Frequency",
                                        values.pkgLogic.frequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      STR Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueDate"
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueType"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueFrequency"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pkgLogic.strDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                </>
                              )}
                              {this.state.showSignage && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pkgLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pkgLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Signage Type (SNG) <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.type"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Chargeable" label="Chargeable" />
                                        <option value="Not Chargeable" label="Not Chargeable" />
                                      </Field>
                                      {this.validator.message(
                                        "Signage Type",
                                        values.pkgLogic.type,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Name
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="pkgLogic.sngName"
                                      />
                                      {this.validator.message(
                                        "SNG Name",
                                        values.pkgLogic.sngName,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Location <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="pkgLogic.location"
                                      />
                                      {this.validator.message(
                                        "SNG Location",
                                        values.pkgLogic.location,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.uom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="per-signage" label="Per Signage" />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="flat-amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "SNG UOM",
                                        values.pkgLogic.uom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {values.pkgLogic.uom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="pkgLogic.onArea"
                                        />
                                        {this.validator.message(
                                          "On Area",
                                          values.pkgLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Rate <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pkgLogic.rate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(e, values, setFieldValue);
                                        }}
                                      />
                                      {this.validator.message(
                                        "SNG Rate",
                                        values.pkgLogic.rate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[this.state.escalationChargeType][this.state.escalationIndex] !== "undefined" &&
                                    this.state.parkingStorageSignage[this.state.escalationChargeType][this.state.escalationIndex].rate !== 0 && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          Escalation %
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pkgLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.pkgLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.rateTerm"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "SNG Rate Term",
                                        values.pkgLogic.rateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pkgLogic.frequency"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "SNG Frequency",
                                        values.pkgLogic.frequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      SNG Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="pkgLogic.sngDueDate"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            name="pkgLogic.sngDueType"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="pkgLogic.sngDueFrequency"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pkgLogic.sngDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                              {this.state.showAddBtn && (
                                <div className="gridColOneByThree">
                                  <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                    <button
                                      className="add_button"
                                      type="button"
                                      onClick={(e) => {
                                        this.addDetails(values, resetForm, setFieldValue);
                                      }}
                                    >
                                      Add
                                    </button>
                                    <button
                                      className="reset_button"
                                      type="reset"
                                      onClick={(e) => {
                                        this.resetDetails(values, resetForm);
                                      }}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          {this.state.toggleParkingForm === false &&
                            this.state.showCharges === true && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    Parking 2W (Free)
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="parkingCharges.parking2W"
                                    />
                                    <ErrorMessage
                                      name="parkingCharges.parking2W"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Parking 4W (Free)
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="parkingCharges.parking4W"
                                    />
                                    <ErrorMessage
                                      name="parkingCharges.parking4W"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Parking Other (Free)
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="parkingCharges.parkingOther"
                                    />
                                    <ErrorMessage
                                      name="parkingCharges.parkingOther"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_10" />
                          </div>
                        </div>
                        {this.mainFormValidator.message(
                          "Parking storage and signage Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple tableSimpleWithNoFlex">
                            <thead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Parking/Storage/ <br /> Signage Logic</th>
                                <th scope="col">Rate/ Flat Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.parkingStorageSignage).map(
                                function (key, index) {
                                  return this.state.parkingStorageSignage[
                                    key
                                  ].map(function (name, index) {
                                    return (
                                      <tr key={"parkingTable" + index}>
                                        <td>{index + 1}</td>
                                        <td>
                                          <a
                                            className="popupLink"
                                            onClick={(e) => {
                                              this.state.popupData = name;
                                              this.openModal();
                                            }}
                                          >
                                            {name.period}
                                          </a>
                                        </td>
                                        <td>
                                          {name.periodTermYY == ""
                                            ? "0"
                                            : name.periodTermYY}
                                          {"-"}
                                          {name.periodTermMM == ""
                                            ? "0"
                                            : name.periodTermMM}
                                          {"-"}
                                          {name.periodTermDD == ""
                                            ? "0"
                                            : name.periodTermDD}
                                        </td>
                                        <td>
                                          {/* {dateFormat(
                                            name.fromDate,
                                            "dd mmm yyyy"
                                          )} */}
                                          {leaseDateFormat(name.fromDate)}
                                        </td>
                                        <td>
                                          {/* {dateFormat(name.toDate, "dd mmm yyyy")} */}
                                          {leaseDateFormat(name.toDate)}
                                        </td>
                                        <td>{name.chargeTypeText}</td>
                                        <td>{name.rate || "-"}</td>
                                        <td>
                                          <button
                                            type="button"
                                            className="tableActionEdit rentalEdit"
                                            onClick={(e) => {
                                              this.editPkg(index, values, key);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPen} />
                                          </button>
                                          {this.state.parkingStorageSignage[key]
                                            .length ==
                                            index + 1 && (
                                              <button
                                                type="button"
                                                className="actionDelete rentalDeleteButton"
                                                onClick={(e) => {
                                                  // if (
                                                  //   window.confirm(
                                                  //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                  //   )
                                                  // ) {
                                                  //   var _rdd =
                                                  //     this.state
                                                  //       .parkingStorageSignage;
                                                  //   _rdd[key].splice(index, 1);
                                                  //   this.setState({
                                                  //     parkingStorageSignage: _rdd,
                                                  //     showForm: true,
                                                  //   });
                                                  //   this.state.period--;
                                                  // }
                                                  this.setState({
                                                    delete: true,
                                                    index_val: index,
                                                    keyvalue: key,
                                                  });

                                                  this.handleReset();
                                                }}
                                              >
                                                <FontAwesomeIcon icon={faTimes} />
                                              </button>
                                            )}
                                        </td>
                                      </tr>
                                    );
                                  }, this);
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>


                  {/* <Form className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="unitFormContainerNew leaseSection parking">
                        <div className="row m-0">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Renewal Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseRenewalTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  From
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  To
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Charges Applicable{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    as="select"
                                    name={"chargesApplicable"}
                                    value={this.state.applicableValue}
                                    onChange={(e) => {
                                      this.state.applicableValue = e.target.value;
                                      this.showParkingForm(e);
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value="Select"
                                      label="Select"
                                      defaultValue
                                    />
                                    <option value="yes" label="Yes" />
                                    <option value="no" label="No" />
                                    <option value="hybrid" label="Hybrid" />
                                  </Field>
                                  {this.applicableValidator.message(
                                    "Charges Applicable",
                                    this.state.applicableValue,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.toggleParkingForm && (
                          <div className="parkingApplicable">
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Charge Type{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"pkgLogic.chargeType"}
                                        disabled={this.state.disableOnEdit}
                                        value={
                                          this.state.initialValues.pkgLogic
                                            .chargeType
                                        }
                                        onChange={(e) => {
                                          this.hadleOptionChange(e, values, setFieldValue);

                                          console.log(this.state.initialValues);
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Parking 2W"
                                          label="Parking 2W"
                                        />
                                        <option
                                          value="Parking 4W"
                                          label="Parking 4W"
                                        />
                                        <option
                                          value="Parking Other"
                                          label="Parking Other"
                                          defaultValue
                                        />
                                        <option value="Storage" label="Storage" />
                                        <option
                                          value="Signage"
                                          label="Signage"
                                          defaultValue
                                        />
                                      </Field>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Period
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="pkgLogic.period"
                                        value={this.state.period}
                                        disabled={this.state.disableOnEdit}
                                        onChange={(e) => {
                                          this.state.period = e.target.value;
                                        }}
                                      />
                                      <ErrorMessage
                                        name="pkgLogic.period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Period Term
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodTermmYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermYY}
                                        onChange={(e) => {
                                          this.state.periodTermYY =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermMM}
                                        onChange={(e) => {
                                          this.state.periodTermMM =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder text-center"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.periodTermDD}
                                        onChange={(e) => {
                                          this.state.periodTermDD =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(e);
                                        }}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="mfLogic.periodTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {this.state.showParking && (
                              <div className="parkingFormContainer">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="pkgLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="pkgLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Count
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pkgLogic.count"
                                          />
                                          {this.validator.message(
                                            "PKG Count",
                                            values.pkgLogic.count,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Rate UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.uom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Slot"
                                              label="Per Slot"
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "PKG UOM",
                                            values.pkgLogic.uom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.pkgLogic.uom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pkgLogic.area"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                              <option
                                                value="Actual Parking Area"
                                                label="Actual Parking Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "PKG Area",
                                              values.pkgLogic.area,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {values.pkgLogic.area ==
                                    "Actual Parking Area" && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PKG Actual Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pkgLogic.actualArea"
                                              />
                                              {this.validator.message(
                                                "PKG Area",
                                                values.pkgLogic.actualArea,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Rate (Per Month)
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pkgLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateEscalationPercent(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "PKG Rate",
                                            values.pkgLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[
                                    this.state.escalationChargeType
                                    ][this.state.escalationIndex] !=
                                    "undefined" &&
                                    this.state.parkingStorageSignage[
                                      this.state.escalationChargeType
                                    ][this.state.escalationIndex].rate != 0 && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pkgLogic.escalationPercent"
                                                disabled={
                                                  this.state.disableOnEdit
                                                }
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.pkgLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.rateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Rate Term",
                                            values.pkgLogic.rateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.frequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Frequency",
                                            values.pkgLogic.frequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PKG Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.pkgDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pkgLogic.pkgDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.applicableValue == 'hybrid' &&
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Free Parking
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pkgLogic.freeParking"
                                            />
                                            {this.validator.message(
                                              "Free parking",
                                              values.pkgLogic.count,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }



                                </div>
                              </div>
                            )}
                            {this.state.showStorage && (
                              <div className="storageContainer">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pkgLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pkgLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row storage">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Storage Type (STR)
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.type"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Basic Store"
                                              label="Basic Store"
                                            />
                                            <option
                                              value="Cold Store "
                                              label="Cold Store "
                                            />
                                            <option
                                              value="Others "
                                              label="Others "
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Storage Type (STR)",
                                            values.pkgLogic.type,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR Name
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="pkgLogic.strName"
                                          />
                                          {this.validator.message(
                                            "STR Name",
                                            values.pkgLogic.strName,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.uom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Slot"
                                              label="Per Slot "
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "STR Uom",
                                            values.pkgLogic.uom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.pkgLogic.uom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="pkgLogic.onArea"
                                            />
                                            {this.validator.message(
                                              "On Area",
                                              values.pkgLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row mt-3">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pkgLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateEscalationPercent(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "STR Rate",
                                            values.pkgLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[
                                    this.state.escalationChargeType
                                    ][this.state.escalationIndex] !=
                                    "undefined" &&
                                    this.state.parkingStorageSignage[
                                      this.state.escalationChargeType
                                    ][this.state.escalationIndex].rate != 0 && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pkgLogic.escalationPercent"
                                                disabled={
                                                  this.state.disableOnEdit
                                                }
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.pkgLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.rateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "STR Rate Term",
                                            values.pkgLogic.rateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.frequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "STR Frequency",
                                            values.pkgLogic.frequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          STR Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.strDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pkgLogic.strDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.showSignage && (
                              <div className="showSignageContainer">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pkgLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pkgLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Signage Type (SNG)
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.type"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Chargeable"
                                              label="Chargeable"
                                            />
                                            <option
                                              value="Not Chargeable "
                                              label="Not Chargeable "
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Signage Type",
                                            values.pkgLogic.type,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Name
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="pkgLogic.sngName"
                                          />
                                          {this.validator.message(
                                            "SNG Name",
                                            values.pkgLogic.sngName,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row storage">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Location
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="pkgLogic.location"
                                          />
                                          {this.validator.message(
                                            "SNG Location",
                                            values.pkgLogic.location,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.uom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="per-signage"
                                              label="Per Signage"
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="flat-amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "SNG Uom",
                                            values.pkgLogic.uom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.pkgLogic.uom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="pkgLogic.onArea"
                                            />
                                            {this.validator.message(
                                              "on Area",
                                              values.pkgLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pkgLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateEscalationPercent(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "SNG Rate",
                                            values.pkgLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.period > 1 &&
                                    typeof this.state.parkingStorageSignage[
                                    this.state.escalationChargeType
                                    ][this.state.escalationIndex] !=
                                    "undefined" &&
                                    this.state.parkingStorageSignage[
                                      this.state.escalationChargeType
                                    ][this.state.escalationIndex].rate != 0 && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pkgLogic.escalationPercent"
                                                disabled={
                                                  this.state.disableOnEdit
                                                }
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.pkgLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.rateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "SNG Rate Term",
                                            values.pkgLogic.rateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pkgLogic.frequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "SNG frequency",
                                            values.pkgLogic.frequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          SNG Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.sngDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.sngDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pkgLogic.sngDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pkgLogic.sngDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {this.state.showAddBtn && (
                              <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                <button
                                  className="add_button"
                                  type="button"
                                  onClick={(e) => {
                                    this.addDetails(values, resetForm, setFieldValue);
                                  }}
                                >
                                  Add
                                </button>
                                <button
                                  className="reset_button"
                                  type="reset"
                                  onClick={(e) => {
                                    this.resetDetails(values, resetForm);
                                  }}
                                >
                                  Reset
                                </button>
                              </div>

                            )}
                          </div>
                        )}
                        {this.state.toggleParkingForm === false &&
                          this.state.showCharges === true && (
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Parking 2W (Free)
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="parkingCharges.parking2W"
                                      />
                                      <ErrorMessage
                                        name="parkingCharges.parking2W"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Parking 4W (Free)
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="parkingCharges.parking4W"
                                      />
                                      <ErrorMessage
                                        name="parkingCharges.parking4W"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Parking Other (Free)
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="text"
                                        name="parkingCharges.parkingOther"
                                      />
                                      <ErrorMessage
                                        name="parkingCharges.parkingOther"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        <span className="remarks">Notes/Remarks</span>
                        <Field as="textarea" className="notes mb-3" name="notes_10" />
                      </div>
                      {this.mainFormValidator.message(
                        "Parking storage and signage Details",
                        this.countError,
                        "required",
                        { className: "text-danger" }
                      )}
                      <div className="tableContainer p-0">
                        <table className="table tableSimple tableSimpleWithNoFlex">
                          <thead>
                            <tr>
                              <th scope="col">S.No</th>
                              <th scope="col">Period</th>
                              <th scope="col">Period Term</th>
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">Parking/Storage/ <br /> Signage Logic</th>
                              <th scope="col">Rate/ Flat Amount</th>
                              <th scope="col" colSpan="2">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(this.state.parkingStorageSignage).map(
                              function (key, index) {
                                return this.state.parkingStorageSignage[
                                  key
                                ].map(function (name, index) {
                                  return (
                                    <tr key={"parkingTable" + index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <a
                                          className="popupLink"
                                          onClick={(e) => {
                                            this.state.popupData = name;
                                            this.openModal();
                                          }}
                                        >
                                          {name.period}
                                        </a>
                                      </td>
                                      <td>
                                        {name.periodTermYY == ""
                                          ? "0"
                                          : name.periodTermYY}
                                        {"-"}
                                        {name.periodTermMM == ""
                                          ? "0"
                                          : name.periodTermMM}
                                        {"-"}
                                        {name.periodTermDD == ""
                                          ? "0"
                                          : name.periodTermDD}
                                      </td>
                                      <td>
                                        {leaseDateFormat(name.fromDate)}
                                      </td>
                                      <td>
                                        {leaseDateFormat(name.toDate)}
                                      </td>
                                      <td>{name.chargeTypeText}</td>
                                      <td>{name.rate || "-"}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="tableActionEdit rentalEdit"
                                          onClick={(e) => {
                                            this.editPkg(index, values, key);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {this.state.parkingStorageSignage[key]
                                          .length ==
                                          index + 1 && (
                                            <button
                                              type="button"
                                              className="actionDelete rentalDeleteButton"
                                              onClick={(e) => {
                                                // if (
                                                //   window.confirm(
                                                //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                //   )
                                                // ) {
                                                //   var _rdd =
                                                //     this.state
                                                //       .parkingStorageSignage;
                                                //   _rdd[key].splice(index, 1);
                                                //   this.setState({
                                                //     parkingStorageSignage: _rdd,
                                                //     showForm: true,
                                                //   });
                                                //   this.state.period--;
                                                // }
                                                this.setState({
                                                  delete: true,
                                                  index_val: index,
                                                  keyvalue: key,
                                                });

                                                this.handleReset();
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                          )}
                                      </td>
                                    </tr>
                                  );
                                }, this);
                              },
                              this
                            )}
                          </tbody>
                        </table>
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" className="add_button">
                            Save Draft
                          </button>
                          <button type="reset" className="reset_button">
                            <Link to="/createlease">
                              Cancel
                            </Link>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Parking Storage & Signage Charges</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.pssPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  pssPopup(pss) {
    if (
      pss.chargeTypeText == "Parking 2W" ||
      pss.chargeTypeText == "Parking 4W" ||
      pss.chargeTypeText == "Parking Other"
    ) {
      return this.parkingPopup(pss);
    } else if (pss.chargeTypeText == "Storage") {
      return this.storagePopup(pss);
    } else if (pss.chargeTypeText == "Signage") {
      return this.signagePopup(pss);
    }
  }

  parkingPopup(pss) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Charge Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.chargeTypeText}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pss.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pss.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Count <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.count}</label>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Rate Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateType}
                </label>
              </div>
            </div>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.rate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.uom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.area}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Actual Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.actualArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.pkgDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PKG Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.frequency}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  storagePopup(pss) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Charge Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.chargeTypeText}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pss.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pss.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Storage Type (STR) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.type}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Name <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.strName}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Rate Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.rate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.uom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.strDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  STR Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.frequency}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  signagePopup(pss) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Charge Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.chargeTypeText}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.fromDate}
                  {leaseDateFormat(pss.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pss.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Storage Type (SNG) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.type}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Name <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.sngName}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Rate Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.rate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.uom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pss.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.sngDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.rateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.frequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  SNG Location <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pss.location}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ParkingStorageSignage);
